import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversiteDeMontreal = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Université de Montréal"
      universityShortName="UdeM"
      slug="universite-de-montreal"
      seoTitle="Université de Montréal Study Rooms | Montreal Campus Study Guide"
      seoDescription="Complete guide to study rooms at Université de Montréal. Find sound-insulated cabins, group rooms, and innovation spaces. Plus free 24/7 online alternative."
      seoKeywords="universite de montreal study rooms, udem library, montreal university study spaces, cabines insonorisees, udem bibliotheque"
      canonicalUrl="/study-room/universite-de-montreal/"
      heroDescription="A comprehensive guide to study rooms at UdeM, including sound-insulated cabins, silent rooms, and innovation spaces."
      libraryWebsiteUrl="https://bib.umontreal.ca/"
      libraryWebsiteName="UdeM Libraries"
      studySpaces={[
        {
          name: "Individual Study Rooms",
          features: "Private rooms for focused individual work.",
          feedback: "Good for concentrated study; book in advance."
        },
        {
          name: "Sound-Insulated Cabins (Cabines Insonorisées)",
          features: "Soundproof booths perfect for online meetings and calls.",
          feedback: "Popular cabins booked far in advance; ideal for video calls."
        },
        {
          name: "Group Rooms (3-4 and 4-8 people)",
          features: "Various sizes for small to medium group collaboration.",
          feedback: "Versatile options; availability varies by branch."
        },
        {
          name: "Silent Rooms (Law, Marguerite-d'Youville, Veterinary Medicine)",
          features: "Designated silent study areas in specialized libraries.",
          feedback: "Complete silence enforced; great for exam preparation."
        },
        {
          name: "Innovation and Creativity Spaces (Math & CS, Marguerite-d'Youville)",
          features: "Spaces for creative work and digital tools exploration.",
          feedback: "Great for collaborative and innovative projects."
        },
        {
          name: "Graduate and Doctoral Rooms",
          features: "Reserved spaces for graduate law students and doctoral candidates.",
          feedback: "Exclusive access for eligible students."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Reserve your preferred room via the LibCal site; <strong>cabins are perfect for online meetings</strong>. For complete silence, head to the <strong>Law Library or Marguerite-d'Youville</strong>.
          </p>
          <p className="mb-4">
            If you want to collaborate or explore digital tools, the <strong>Math & Computer Science library's innovation spaces</strong> are ideal.
          </p>
          <p>
            Students like the variety of spaces, from silent areas to creative labs, but some complain that popular cabins are booked far in advance.
          </p>
        </>
      }
      summaryTips={[
        "Book sound-insulated cabins early: Perfect for video calls but very popular.",
        "Use Law Library for silence: Complete quiet enforced for exam preparation.",
        "Explore innovation spaces: Math & CS library offers creative collaboration tools.",
        "Check various branches: Silent rooms available at Law, Marguerite-d'Youville, and Veterinary Medicine.",
        "Use CSW for instant access: No advance booking needed for virtual study rooms."
      ]}
    />
  );
};

export default UniversiteDeMontreal;
